<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="headline">
        Edytuj mapę
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-text-field
                  v-model="map.name"
                  :rules="formRules.name"
                  class="pt-0"
                  type="url"
                  label="Nazwa mapy"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-textarea
                  v-model="map.code"
                  :rules="formRules.code"
                  class="pt-0"
                  type="url"
                  label="Kod mapy"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                large
            >Zapisz&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalEditMap',
  props: {
    item: {},
  },
  created() {
  },
  data() {
    return {
      dialog: false,
      form: {
        name: '',
        code: '',
      },
      formRules: {
        name: [(value) => !!value || 'Wpisz nazwy mapy'],
        code: [(value) => !!value || 'Wpisz kod mapy'],
      },
      valid: false,
      redirect: {
        name: '',
        code: '',
      },
    }
  },
  methods: {
    open(map) {
      this.map = map;
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const map = {
        name: this.map.name,
        code: this.map.code,
      }
      api
          .put('/api/maps/' + this.map.id, map)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Mapa została zaktualizowana',
            });
            this.dialog = false;
          })
          .catch((error) => {
            console.error('Error when editing a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
